import { Observable } from "rxjs";



export class CacheStorageModel<T> {
    expires: number = 0;
    observable: Observable<T>; 
    
    constructor(exp:number,observable:Observable<T>){
        this.expires = exp;
        this.observable = observable;
    }
}